import { DELETE_GIF } from '../../../utills/image-constant';

const DeleteModal = ({ title, DeleteModalRef, handleDelete, warningMsg = "", name }) => {
    return (
        <div className="deleteModel">
            <button type="button" className="d-none btn btn-primary" data-bs-toggle="modal" data-bs-target="#deleteModel" ref={DeleteModalRef}>
            </button>

            <div className="modal fade logout_body" id="deleteModel" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header logout_header">
                            <img src={DELETE_GIF} alt='Logout Icon' className='img-fluid' />
                        </div>
                        <div className="modal-body border-0">
                            <h6 className='text-center'>{warningMsg}</h6>
                            <h5 className="modal-title text-danger" id="staticBackdropLabel">Are you sure you want to delete {name} {title}!</h5>
                        </div>
                        <div className="modal-footer logout_footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={handleDelete}>Confirm</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteModal;